import AppHeader from "../../layout/AppHeader";
import InvoiceAdd from '../../xpost/views/financial/invoice/InvoiceAdd.vue';
import InvoiceSingle from '../../xpost/views/financial/invoice/InvoiceSingle.vue';

const InvoiceRoutes = [
    {
        path: "/financeiro/fatura",
        name: "invoice.add",
        components: {
            header: AppHeader,
            default: InvoiceAdd,
        }
    },
    {
        path: "/financeiro/fatura/avulsa",
        name: "invoice.single",
        components: {
            header: AppHeader,
            default: InvoiceSingle,
        }
    },
]

export default InvoiceRoutes;